import {
  GET_LOCATIONS_CATALOG,
  GET_LOCATIONS_CATALOG_SUCCESS,
  GET_LOCATIONS_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const getLocationsCatalogRed = (state: any, actions: any) => {
  switch (actions.type) {
    case GET_LOCATIONS_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case GET_LOCATIONS_CATALOG_ERROR:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case GET_LOCATIONS_CATALOG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
